import { Component, Input, forwardRef, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { FormDndValidateDirective } from '../../directives/forms/form-dnd-validate.directive';
import { SafePipe } from '../../pipes/safe.pipe';


@Component({
	selector: 'btn-switch',
	templateUrl: './btn-switch.component.html',
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BtnSwitchComponent),
		multi: true
	}],
	imports: [FormDndValidateDirective, NgbTooltipModule, TranslateModule, SafePipe]
})
export class BtnSwitchComponent {
	@Input() label = 'Actions.Activate';
	@Input() labelTrust: 'none' | 'html' = 'none';
	@Input() tooltipMessage: string;
	@Input() noLabel = false;
	@Input() isRevert = false;
	@Input() isInvalid = false;

	@Input() onLabel = 'CommonStatus.Enable';
	@Input() offLabel = 'CommonStatus.Disable';

	private _checked: boolean;
	private disabled: boolean;

	@Input()
	set checked(checked: boolean) {
		this._checked = checked;
	}

	get checked() {
		return this._checked;
	}

	@Input()
	set isDisabled(disabled: boolean) {
		this.disabled = disabled;
	}

	get isDisabled() {
		return this.disabled;
	}

	@Output() valueChange = new EventEmitter<boolean>();

	constructor(private cdr: ChangeDetectorRef) {
	}

	onChange(event: Event) {
		if (this.isDisabled) {
			return;
		}

		event.preventDefault();
		event.stopPropagation();

		this.checked = !this.checked;

		// Component events
		this.valueChange.emit(this.checked);

		// value accessor callbacks
		this.onChangeCallback(this.checked);
		this.onTouchedCallback(this.checked);
		this.cdr.markForCheck();
	}

	writeValue(checked: boolean): void {
		this.checked = checked;
		if (this.cdr) {
			this.cdr.markForCheck();
		}
	}

	registerOnChange(fn: any) {
		this.onChangeCallback = fn;
	}

	registerOnTouched(fn: any) {
		this.onTouchedCallback = fn;
	}

	setDisabledState(isDisabled: boolean) {
		this.isDisabled = isDisabled;
	}

	private onTouchedCallback = (v: any) => v;
	private onChangeCallback = (v: any) => v;
}
